<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    const dispatch = createEventDispatcher()
    import Fa from 'svelte-fa'
    import { faAngleLeft, faEdit, faPlusCircle, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import Zact from '../../_common/z/zact.svelte'
    import { ResourceLock } from '../../../modules/schedulerApi/resources-lock/resource-lock'
    import type { CreateResourceLockDto } from '../../../modules/schedulerApi/resources-lock/dto/create-resource-lock.dto'
    import type { UpdateResourceLockDto } from '../../../modules/schedulerApi/resources-lock/dto/update-resource-lock.dto'
    // ##############################################################################################################

    export let form: boolean = false
    export let resourceLockId: string = null
    let resourceLock: ResourceLock = new ResourceLock()

    async function editEntity(id: string) {
        try {
            show = true
            step = 2
            resourceLock = new ResourceLock()
            resourceLock = await window.api.schedulers.resourcesLock.getOne(id)
            console.log('resource-lock', resourceLock)
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function newEntity() {
        resourceLock = new ResourceLock()
        step = 2
    }

    async function createEntity() {
        try {
            show = true
            const dto: CreateResourceLockDto = {
                label: resourceLock.label,
            }
            resourceLock = await window.api.schedulers.resourcesLock.create(dto)
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function sendClose() {
        dispatch('close')
    }

    async function updateEntity() {
        try {
            show = true
            const dto: UpdateResourceLockDto = {
                label: resourceLock.label,
            }
            await window.api.schedulers.resourcesLock.update(resourceLock.resourcesLockId, dto)
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function saveEntity() {
        if (resourceLock.resourcesLockId) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    async function loadEntities() {
        try {
            show = true
            step = 1
            entities = await window.api.schedulers.resourcesLock.getAll()
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Salas e Aparelhos'
        grid.subtitle = ''
        grid.cols.push(new GridCol({ content: 'Nome' }))
        grid.cols.push(new GridCol({ content: 'Data de cadastro', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            const btn = new GridButton({
                callback: () => editEntity(item.resourcesLockId),
                icon: faEdit,
                label: 'Editar',
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.label })
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: [btn] })
            grid.lines.push(line)
        }
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await window.api.schedulers.resourcesLock.remove(resourceLock.resourcesLockId)
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function showEntities() {
        step = 1
    }

    let show = false
    let step = 1
    let entities: ResourceLock[] = []

    onMount(async () => {
        await loadEntities()
        if (form) {
            if (resourceLockId) {
                await editEntity(resourceLockId)
            } else {
                await newEntity()
            }
        }
    })
</script>

<div>
    {#if step === 1}
        <Zact>
            <div class="spacer" />
            <button class="btn btn-primary" on:click={newEntity}><Fa icon={faPlusCircle} /> Novo</button>
        </Zact>
        <Zgrid class="mt-3" {grid} />
    {/if}
    {#if step === 2}
        <Zact>
            {#if !form}
                <button class="btn btn-secondary" on:click={showEntities}><Fa icon={faAngleLeft} /> Voltar</button>
            {/if}
            <div class="spacer" />
            {#if !!resourceLock.resourcesLockId}
                <button class="btn btn-warning" on:click={removeEntity}><Fa icon={faTrashAlt} /> Excluir</button>
            {/if}
            <button class="btn btn-primary" on:click={saveEntity}><Fa icon={faSave} /> Salvar</button>
        </Zact>

        <Zframe title="Salas e Aparelhos" class="m-3">
            <div class="grid-form">
                <div class="row">
                    <div class="col">
                        <div class="input-group">
                            <label for="" class="input-group-text">Nome da sala / aparelho</label>
                            <input type="text" bind:value={resourceLock.label} class="form-control" />
                        </div>
                    </div>
                </div>
            </div>
        </Zframe>
    {/if}
</div>
